module.exports = __webpack_public_path__ + "img/category-bg.f75cb265.png";